import requestApi, { get } from '../../../apirest';

export async function fetchAllCustomers() {
  const res = await get('/order/customers');
  return res.data?.customers || [];
}

export async function fetchTemplates() {
  const res = await get('/marketing/templates');
  return res.data?.templates || [];
}

export async function sendWhatsAppCampaign({ contacts, message, contentSid, templateVariables }) {
  const res = await requestApi('/marketing/whatsapp/send', { contacts, message, contentSid, templateVariables }, 'post');
  return res.data;
}

export async function fetchCampaigns() {
  const res = await get('/marketing/campaigns');
  return res.data?.campaigns || [];
}

export async function retryCampaign(id, contentSidOverride) {
  const res = await requestApi(`/marketing/campaigns/${id}/retry`, { contentSidOverride }, 'post');
  return res.data;
}
